export default {
  virtualsoccer: {
    development: {
      baseURL: 'https://games-vsts.dev.de-3.nsoft.cloud',
      tenantConfigURL: 'https://games-vsops.dev.de-3.nsoft.cloud/tenant/config',
    },
    staging: {
      baseURL: 'https://games-vsts.staging.de-3.nsoft.cloud',
      tenantConfigURL: 'https://games-vsops.staging.de-3.nsoft.cloud/tenant/config',
    },
    production: {
      baseURL: 'https://games-vsts.de-3.nsoft.cloud',
      tenantConfigURL: 'https://games-vsops.de-3.nsoft.cloud/tenant/config',
    },
  },
};
